import React from 'react';
import styles from './landing-hero.module.scss';
import { DefaultButton } from 'shared/ui';
import { SmartphoneMockup } from 'shared/svg';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';

export const LandingHero: React.FC = () => {
  const navigate = useNavigate();

  const handleSignUp = () => navigate(AppLinks.SignUpLink);
  const handleDemo = () => {
    const el = document.getElementById('solution-features');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={styles.landing_hero_wrapper}>
      <div className={styles.landing_hero}>
        <div className={styles.landing_hero__content}>
          <div className={styles.hero__badge}>
            30 дней бесплатно для 2 сотрудников
          </div>
          <h1 className={styles.hero__title}>
            Онлайн-запись для салонов красоты и сервисов
          </h1>
          <div className={styles.hero__subtitle}>
            Клиенты записываются сами 24/7. Напоминания в VK снижают неявки до
            нуля. Интеграция с Яндекс Картами.
          </div>
          <div className={styles.hero__buttons}>
            <div className={styles.buttons__cta}>
              <DefaultButton
                buttonText="Попробовать бесплатно"
                color="green"
                onClick={handleSignUp}
              />
            </div>
            <button className={styles.buttons__link} onClick={handleDemo}>
              Посмотреть демо →
            </button>
          </div>
        </div>
        <div className={styles.landing_hero__visual}>
          <div className={styles.visual__phone}>
            <SmartphoneMockup
              imageUrl="/screenshots/customer-booking.png"
              alt="Онлайн-запись клиентов через мобильное устройство"
            />
          </div>
          <div className={styles.visual__dashboard}>
            <img
              src="/screenshots/business-dashboard.png"
              alt="Панель управления бизнесом"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
